import {Injectable} from '@angular/core';
import {Http} from "@angular/http";
import {tokenNotExpired} from 'angular2-jwt';
import {ApiService} from "./api.service";
import {DataService} from "./data.service";

@Injectable()
export class AuthService {
    private ApiUrl;

    constructor(
        private http: Http,
        private apiService: ApiService,
        private dataService: DataService
    ) {
        this.ApiUrl = apiService.getApiUrl();
    }

    login(data) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + 'login';
        return this.http.post(url, data);
    }

    loggedIn() {
        return tokenNotExpired();
    }

    logout() {
        localStorage.removeItem('token');
    }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts